import Skeleton from "./Skeleton";
import TableLoadingSkeleton from "./TableLoadingSkeleton";

export default function TableSkeleton() {
  return (
    <div className="flex flex-col gap-5">
      <Skeleton size="3xl" className="w-28" />
      <div className="flex flex-col gap-1">
        <Skeleton size="xl" className="w-56" />
        <Skeleton size="sm" className="w-full max-w-sm" />
      </div>
      <div className="flex gap-5">
        <Skeleton size="3xl" className="w-28" />
        <Skeleton size="3xl" className="w-28" />
        <Skeleton size="3xl" className="w-28" />
        <Skeleton size="3xl" className="w-28" />
      </div>
      <div className="flex gap-5 rounded-xl bg-gray-50 p-3">
        <Skeleton size="2xl" className="w-full max-w-md" />
        <Skeleton size="2xl" className="w-48" />
      </div>
      <div>
        <div className="flex items-center gap-1 bg-gray-50 px-3 py-5">
          <Skeleton size="xl" className="w-40 max-w-md" />
          <Skeleton size="sm" className="w-20 max-w-md" />
          <Skeleton size="xl" className="ms-auto w-40 max-w-md" />
        </div>
        <TableLoadingSkeleton />
      </div>
    </div>
  );
}
